import React, { useContext, useEffect, useState } from "react";
import GraphAnalytics from "./GraphAnalytics";
import { useNavigate } from "react-router-dom";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import AppContext from "../../../AppContext";
import { Calendar } from "@progress/kendo-react-dateinputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import axios from "axios";
import { BASE_URL } from "../../../constant";
import { useTranslation } from "react-i18next";
const CostAnalytics = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { assets, darkMode } = useContext(AppContext);
  const [filterState, setFilterState] = useState({
    asset: "all",
    timeMode: "weekToDate",
    startDate: null,
    endDate: null,
    date: new Date(),
  });
  const [assetData, setAssetData] = useState([{ id: "all", name: "ALL" }]);
  const [calculatedData, setCalculatedData] = useState({
    idleTime: [],
    speedAbove100Data: [],
    speedAbove120Data: [],
    totalIdleTime: 0,
    averageFuelCostForIdle: 0,
    veryHighEngineRPMTime: 0,
    speedAbove100Time: 0,
    speedAbove120Time: 0,
    totalFuelCost: 0,
    totalRefuelValue: 0,
    totalConsumedAmountLiters: 0,
  });

  useEffect(() => {
    if (assets)
      setAssetData([
        { id: "all", name: "ALL" },
        ...assets.map((x) => ({
          id: x.id,
          name: x.name,
        })),
      ]);
  }, [assets]);

  useEffect(() => {
    handleApplyFilter();
  }, []);

  const handleApplyFilter = () => {
    const { asset, date } = filterState;
    const assetName =
      asset !== "all" ? assetData.find((x) => x.id === asset).name : asset;
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const apiUrl = `${BASE_URL}/api/AnalyticsData?name=${encodeURIComponent(
      assetName
    )}&year=${year}&month=${month}`;

    // Make the API call using Axios
    axios
      .get(apiUrl)
      .then((response) => {
        formatData(response.data);
      })
      .catch((error) => {
        // Handle errors
        console.error("Error fetching data:", error);
        // You can set an error state or display an error message to the user
      });
  };
  const formatData = (dataArray) => {
    const idleTime = dataArray.map((item) => ({
      x: new Date(item.local_date),
      y: item.idleTimeOnIgnitionHrs,
    }));

    // Transform speed above 100 data
    const speedAbove100Data = dataArray.map((item) => ({
      x: new Date(item.local_date),
      y: item.highSpeedAbove100Count,
    }));

    // Transform speed above 120 data
    const speedAbove120Data = dataArray.map((item) => ({
      x: new Date(item.local_date),
      y: item.highSpeedAbove120Count,
    }));
    // Calculate total idle time in hours
    const totalIdleTime = dataArray.reduce(
      (acc, item) => acc + item.idleTimeOnIgnitionHrs,
      0
    );
    // Calculate average fuel cost for idle time
    const totalFuelCostForIdle = dataArray.reduce(
      (acc, item) => acc + item.totalFuelCost,
      0
    );
    const averageFuelCostForIdle = totalFuelCostForIdle / totalIdleTime;

    // Calculate very high engine RPM time
    const veryHighEngineRPMTime = dataArray.reduce(
      (acc, item) => acc + item.engineRPMAbove3500Hrs,
      0
    );

    // Calculate speed above 100 in hours
    const speedAbove100Time = dataArray.reduce(
      (acc, item) => acc + item.highSpeedAbove100TimeHrs,
      0
    );

    // Calculate speed above 120 in hours
    const speedAbove120Time = dataArray.reduce(
      (acc, item) => acc + item.highSpeedAbove120TimeHrs,
      0
    );

    const totalFuelCost = dataArray.reduce(
      (acc, item) => acc + item.totalFuelCost,
      0
    );

    const totalConsumedAmountLiters = dataArray.reduce(
      (acc, item) => acc + item.totalFuelConsumedLtrs,
      0
    );
    setCalculatedData({
      idleTime,
      speedAbove100Data,
      speedAbove120Data,
      totalIdleTime: totalIdleTime / dataArray.length,
      averageFuelCostForIdle,
      veryHighEngineRPMTime,
      speedAbove100Time,
      speedAbove120Time,
      totalFuelCost,
      totalConsumedAmountLiters,
    });
  };

  const GetCalendar = (props) => {
    return <Calendar {...props} bottomView="year" topView="decade" />;
  };
  function formatTime(timeInHours) {
    // Check if timeInHours is not a valid number or is NaN
    if (isNaN(timeInHours) || typeof timeInHours !== "number") {
      timeInHours = 0;
    }

    var hours = Math.floor(timeInHours);
    var minutes = Math.round((timeInHours - hours) * 60);

    if (hours === 0) {
      return (
        <div className="flex items-end">
          {minutes}
          <span className="text-sm"> {t("masters.labels.minute")}</span>
        </div>
      );
    } else if (minutes === 0) {
      return (
        <div className="flex items-end">
          {hours}
          <span className="text-sm"> {t("masters.labels.hour")}</span>
        </div>
      );
    } else {
      return (
        <div className="flex items-end">
          {hours} <span className="text-sm"> {t("masters.labels.hour")}</span>{" "}
          {minutes}
          <span className="text-sm"> {t("masters.labels.minute")}</span>
        </div>
      );
    }
  }

  return (
    <div className="flex flex-col p-5 h-full dark:bg-neutral-900 bg-lightModeBg">
      <div className="font-medium dark:text-white text-labels flex items-center justify-between">
        <div className="flex text-xl items-center gap-2">
          <button type="button" onClick={() => navigate("/analytics")}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2.0"
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          </button>
          {t("masters.headerTexts.costAnalyt")}
        </div>
        <div className="flex gap-2">
          <div id="compo" className={`${darkMode ? "darkCombo" : "lightCombo"}`}>
            <ComboBox
              id="default-search"
              textField="name"
              data={assetData}
              dataItemKey="id"
              name="asset"
              style={{
                fontSize: "12px",
                fontWeight: "500",
                borderColor: "transparent",
              }}
              clearButton={false}
              className=" block border-gray-400 dark:text-white text-inputFieldsTxts rounded-lg mb-4 h-8"
              placeholder="Select Asset"
              onChange={(event) =>
                setFilterState((prevState) => ({
                  ...prevState,
                  asset: event.target.value.id,
                }))
              }
              value={assetData.find((x) => x.id === filterState.asset) || null}
              required
            />
          </div>
          <div className={`inline-flex relative rounded group h-8 z-30 w-fit dark:border-black border ${darkMode ? "darkCombo" : "lightCombo"}`}>
            <DatePicker
              format="MMMM-yyy"
              style={{
                fontSize: "12px",
                fontWeight: "500",
                borderColor: "transparent",
              }}
              className=" block border-gray-400 dark:text-white text-inputFieldsTxts rounded-lg mb-4 h-8"
              value={filterState.date}
              onChange={(e) =>
                setFilterState((pre) => ({ ...pre, date: e.value }))
              }
              calendar={(props) => GetCalendar(props)}
            />
          </div>
          <button
            type="button"
            className="dark:bg-indigo-600 bg-applyBtn md:px-2 text-xs px-1 font-medium md:h-7 h-5 my-auto rounded"
            onClick={handleApplyFilter}
          >
            {t("button.apply")}
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 h-full pb-2 pt-4 gap-4 dark:bg-neutral-900 bg-lightModeBg">
        <div className="flex justify-between dark:bg-neutral-900 bg-lightModeBg">
          <div className="rounded-md px-4 py-3 w-full flex flex-col gap-2 items-center justify-center">
            <div className="text-5xl dark:text-white text-black">
              {formatTime(calculatedData.totalIdleTime)}
            </div>
            <div className="text-sm dark:text-gray-400 text-labels">
              {t("masters.labels.avgIdlTimeIgnition")}
            </div>
          </div>
          <div className="rounded-md px-4 py-3 w-full flex flex-col gap-2 items-center justify-center">
            <div className="text-5xl dark:text-white text-black">
              {calculatedData.averageFuelCostForIdle
                ? calculatedData.averageFuelCostForIdle.toFixed(2)
                : 0}
              <span className="text-sm">AED</span>
            </div>
            <div className="text-sm dark:text-gray-400 text-labels">
              {t("masters.labels.avgFuelCostIdlTime")}
            </div>
          </div>
          <div className="rounded-md px-4 py-3 w-full flex flex-col gap-2 items-center justify-center">
            <div className="text-5xl dark:text-white text-black">
              {calculatedData.totalFuelCost
                ? calculatedData.totalFuelCost.toFixed(2)
                : 0}
              <span className="text-sm">AED</span>
            </div>
            <div className="text-sm dark:text-gray-400 text-labels">
              {t("masters.labels.ttlFuelCost")}
            </div>
          </div>
          <div className="rounded-md px-4 py-3 w-full flex flex-col gap-2 items-center justify-center">
            <div className="text-5xl dark:text-white text-black">
              {calculatedData.totalConsumedAmountLiters
                ? calculatedData.totalConsumedAmountLiters.toFixed(2)
                : 0}
              <span className="text-sm"> {t("masters.labels.ltr")}</span>
            </div>
            <div className="text-sm dark:text-gray-400 text-labels">
              {" "}
              {t("masters.labels.ttlConsumedAmount")}
            </div>
          </div>
          <div className="rounded-md px-4 py-3 w-full flex flex-col gap-2 items-center justify-center">
            <div className="text-5xl dark:text-white text-black">
              {formatTime(calculatedData.veryHighEngineRPMTime)}
            </div>
            <div className="text-sm dark:text-gray-400 text-labels">
              {t("masters.labels.veryHighEnginRpmTime")}
            </div>
          </div>
        </div>
        <div className="h-[37vh] mb-4 dark:bg-neutral-900 bg-lightModeBg">
          <label className="text-base dark:text-white text-labels font-medium">
            {t("masters.labels.ttlIdlTimeHours")}
          </label>
          <div className="h-full">
            <GraphAnalytics
              id={3}
              data={[calculatedData.idleTime]}
              graphType="Column"
            />
          </div>
        </div>
        <div className="h-[35vh] mb-4 dark:bg-neutral-900 bg-lightModeBg">
          <div className="h-full flex items-center w-full gap-10">
            <div className="flex flex-col w-1/5 gap-3">
              <label className="text-base dark:text-white text-labels text-center font-medium">
                {t("masters.labels.speedAbove100")}
              </label>
              <div class="h-52 w-52 text-5xl font-semibold self-center dark:text-white text-labels flex justify-center items-center rounded-full p-6 dark:bg-[#2bb35a] bg-[#00C6C2] dark:border-[#2bb35a] border-[#00C6C2] border   shadow ">
                {formatTime(calculatedData.speedAbove100Time)}
              </div>
            </div>
            <div className="w-4/5">
              <label className="text-sm dark:text-white text-labels font-medium">
                {t("masters.labels.noOfSpeedAbove100")}
              </label>
              <div className="h-[30vh]">
                <GraphAnalytics
                  id={4}
                  data={[calculatedData.speedAbove100Data]}
                  graphType="Line"
                  color={"#2bb35a"}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="h-[35vh] pb-10 dark:bg-neutral-900 bg-lightModeBg">
          <div className="h-full flex items-center w-full gap-10">
            <div className="flex flex-col w-1/5 gap-3">
              <label className="text-base text-center dark:text-white text-labels font-medium">
                {t("masters.labels.speedAbove120")}
              </label>
              <div class="h-52 w-52 text-5xl font-semibold self-center dark:text-white text-labels flex justify-center items-center rounded-full p-6 bg-[#ad7411] border-[#ad7411] border   shadow ">
                {formatTime(calculatedData.speedAbove120Time)}
              </div>
            </div>
            <div className="w-4/5">
              <label className="text-sm dark:text-white text-labels font-medium">
                {t("masters.labels.noOfspeedAbove120")}
              </label>
              <div className="h-[30vh]">
                <GraphAnalytics
                  id={4}
                  data={[calculatedData.speedAbove120Time]}
                  graphType="Line"
                  color={"#ad7411"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CostAnalytics;
